
import * as React from 'react';
import Modal from '@mui/material/Modal';
import { VForm, useVForm } from "../../forms";
import { useState } from "react";
import {
    Box, Grid, Icon, LinearProgress,
    Typography, Button, DialogActions, DialogContent, DialogTitle,
} from "@mui/material";
import { IListagemUsuario, userService } from "../../services/api/user/userService";
import { AutoCompleteManager } from '../autoCompleteManagers/AutoCompleteManager';
import { ToastContent } from '../../../shared/components';
import { useToast } from '../../../shared/hooks';
import { useDebounce } from "../../hooks";
import { returnMessageError } from '../../utils/returnMessageError';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '30%',
    bgcolor: 'background.paper',
    border: '1px solid #605e5e',
    boxShadow: 24,
    p: 2,
    borderRadius: '6px'
};

const typeMessage: ITypeMessage[] = [
    {
        type: 'error',
        title: 'Erro',
        icon: 'cancel_Outlined_Icon',
        color: '#e87b9e'
    },
    {
        type: 'alert',
        title: 'Atenção',
        icon: 'info_Outlined_Icon',
        color: '#ffc107'
    },
    {
        type: 'success',
        title: 'Sucesso',
        icon: 'check_circle_Outline_Icon',
        color: '#39c463'
    },
    {
        type: 'info',
        title: 'Informação',
        icon: 'error_outline_Outlined_Icon',
        color: '#3f51b5'
    },
];

interface ITypeMessage {
    title: string;
    icon: string;
    color: string;
    type: string;
}

interface IManagerModalProps {
    textButtonConfirm?: string;
    showButtonCancel?: boolean;
    isOpenModal: boolean;
    messageType: string;
    onclickConfirm?: () => void;
    isCloseModal: () => void;
    managers: IListagemUsuario[];
    idClient: string;
}

export const ManagerModal: React.FC<IManagerModalProps> = ({ textButtonConfirm,
    showButtonCancel, isOpenModal, messageType, managers, isCloseModal, onclickConfirm, idClient }) => {
    showButtonCancel = true;
    textButtonConfirm = 'Adicionar';

    const setTypeMessage = () => {
        switch (messageType) {
            case 'error':
                return typeMessage[0];
            case 'alert':
                return typeMessage[1];
            case 'success':
                return typeMessage[2];
            case 'info':
                return typeMessage[3];
            default: return typeMessage[0];
        }
    }

    const { formRef } = useVForm();
    const messageStyle: ITypeMessage = setTypeMessage();
    const [isLoading, setIsLoading] = useState(false);
    const [userSelected, setUserSelected] = useState<IListagemUsuario | null>(null);
    const toastHandler = useToast();
    const { debounce } = useDebounce();

    const handleCancel = () => {
        setUserSelected(null);
    }

    const handleSave = () => {
        if (userSelected) {
            setIsLoading(true);
            debounce(() => {
                userService.addManagerByClient({ userId: userSelected.id, clientId: idClient, status: userSelected.status })
                    .then((result: any) => {
                        setIsLoading(false);
                        if (result instanceof Error) {
                            const titleMessage = "Alerta!!";
                            const contentMessage = "Erro: " + result?.message;

                            toastHandler.present({
                                type: 'error',
                                position: 'top-right',
                                messageOrContent: <ToastContent title={titleMessage} content={contentMessage} />
                            })
                        } else {
                            const titleMessage = "Sucesso";
                            const contentMessage = "Gestor adicionado com sucesso!";

                            toastHandler.present({
                                type: 'success',
                                position: 'top-right',
                                messageOrContent: <ToastContent title={titleMessage} content={contentMessage} />
                            });
                            setUserSelected(null);
                        }

                    }).catch((err: any) => {
                        setIsLoading(false);
                        const { titleMessage, contentMessage } = returnMessageError(err);

                        toastHandler.present({
                            type: 'error',
                            position: 'top-right',
                            messageOrContent: <ToastContent title={titleMessage} content={contentMessage} />
                        })
                    })
            });
        }
    }

    return (
        <div>
            <Modal
                open={isOpenModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <DialogTitle style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Icon style={{ color: `${messageStyle.color}`, fontSize: "3rem", fontWeight: 100 }}>
                            {messageStyle.icon}
                        </Icon>
                        <Typography
                            variant='caption'
                            color={`${messageStyle.color}`}
                            marginBottom="1rem"
                        >
                            {messageStyle.title}
                        </Typography>
                        <Typography
                            id="modal-modal-title"
                            variant="h6"
                            color={`${messageStyle.color}`}
                        >
                            Adicionar Gestor
                        </Typography>
                    </DialogTitle>
                    <DialogContent style={{ display: 'flex', justifyContent: 'center' }}>
                        <Typography
                            id="modal-modal-description"
                            sx={{ mt: 2, mb: 2, color: "#7d7d7d", width: "100%" }}
                        >
                            <VForm
                                id="formIdSave"
                                placeholder="Your placeholder"
                                onPointerEnterCapture={() => console.log("Pointer entered")}
                                onPointerLeaveCapture={() => console.log("Pointer left")}
                                ref={formRef} onSubmit={handleSave}>
                                <Grid container direction="column" padding={1} spacing={2} >
                                    {isLoading && (
                                        <Grid item>
                                            <LinearProgress variant="indeterminate" />
                                        </Grid>
                                    )}
                                    <Grid container item direction="row" spacing={2}>
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <AutoCompleteManager
                                                isExternalLoading={isLoading}
                                                labelSelect={'Gestor'}
                                                managers={managers}
                                                idClient={idClient}
                                                selected={(user: IListagemUsuario | null) => {
                                                    setUserSelected(user);
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </VForm>
                        </Typography>
                    </DialogContent>
                    <DialogActions
                        style={{ display: 'flex', justifyContent: 'center' }}
                    >
                        {showButtonCancel && (
                            <Button
                                onClick={isCloseModal}
                                color="primary"
                                disableElevation
                                variant={"text"}
                                startIcon={< Icon > closeIcon</Icon >}
                            >
                                Cancelar
                            </Button>
                        )}
                        <Button
                            color="primary"
                            disableElevation
                            variant={"contained"}
                            startIcon={< Icon > checkIcon</Icon >}
                            onClick={() => {
                                formRef.current?.submitForm();
                                onclickConfirm ? onclickConfirm() : false;
                            }}
                        >
                            {textButtonConfirm}
                        </Button>
                        
                    </DialogActions>
                </Box>
            </Modal>
        </div>
    )
}
